<template>
  <el-dialog
    title="历史"
    :visible.sync="visible"
    @close="$emit('update:show', false)"
    :show="show"
    width="45%"
  >
    <el-table :data="dataList" :border="true" height="200px">
      <el-table-column property="id" label="id" align="center" width="60"></el-table-column>
      <el-table-column property="name" label="节点名称" align="center" width="100"></el-table-column>
      <el-table-column
        property="startTime"
        label="开始时间"
        :formatter="formatDate"
        align="center"
        width="150"
      ></el-table-column>
      <el-table-column
        property="endTime"
        label="结束时间"
        :formatter="formatDate"
        align="center"
        width="150"
      ></el-table-column>
      <el-table-column property="operator" label="操作人" align="center" width="100"></el-table-column>
      <el-table-column property="buttonName" label="操作" align="center" width="120"></el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import moment from 'moment'
export default {
  name: 'process-stateview',
  props: {
    modalObj: String,
    show: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dataList: [],
      visible: this.show
    }
  },
  methods: {
    getData () {
      let that = this
      let params = {
        'instanceId': this.modalObj
      }
      this.$axios.get('/process-api/runtime/getTaskHistory', {
        params
      }).then(function (resp) {
        that.dataList = resp.data
      }).catch(function (e) {
      })
    },
    formatDate (row, column) {
      var data = row[column.property]
      if (data) {
        return moment(data).format('YYYY-MM-DD HH:mm')
      }
      return data
    }
  },
  watch: {
    show () {
      this.visible = this.show ? this.show : !this.show
      if (this.show) {
        this.getData()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/process/runtime/process-stateView.vue